import { CircleLoader } from "@shared/components/CircleLoader/CircleLoader";
import { OAuthLandingPage } from "@unauthenticated/oauth/components/CanadaOAuthOnboardingFlow/OAuthLandingStep/OAuthLandingPage/OAuthLandingPage";
import { useUserUnauthenticatedOAuthQuery as useCurrentUserQuery } from "@unauthenticated/oauth/data/queries/UserQuery/User.query.generated";

import { OAuthStep } from "../oauthStep";

import * as styles from "./OAuthExternalApplicationStep.styles";

interface Props {
  target?: string;
  redirectUri: string;
  ssoOrigin?: string;
  onUpdateCurrentStep: (step: OAuthStep) => void;
}

const OAuthExternalApplicationStep = ({
  target,
  redirectUri,
  ssoOrigin,
  onUpdateCurrentStep,
}: Props) => {
  const redirect = () => {
    if (ssoOrigin !== "signup") {
      const url = new URL(redirectUri);
      const externalState = {
        id: currentUserQueryData?.viewer?.user.id,
        type: currentUserQueryData?.viewer?.user.currentUserRole,
      };
      url.searchParams.append(
        "state",
        encodeURIComponent(window.btoa(JSON.stringify(externalState)))
      );

      window.location.assign(url.toString());
    }
  };

  const { data: currentUserQueryData, loading: currentUserQueryLoading } = useCurrentUserQuery({
    onCompleted: redirect,
    fetchPolicy: "network-only",
  });

  if (currentUserQueryLoading && !currentUserQueryData) return null;
  if (currentUserQueryData?.viewer) {
    redirect();
    if (ssoOrigin !== "signup") {
      return (
        <span className="fa-3x" css={styles.loadingStyles}>
          <CircleLoader />
        </span>
      );
    } else {
      onUpdateCurrentStep(OAuthStep.CERTIFICATION);
    }
  } else if (!currentUserQueryLoading) {
    if (ssoOrigin === "signin" || target === "signin") {
      onUpdateCurrentStep(OAuthStep.SIGN_IN);
    } else if (ssoOrigin === "signup") {
      onUpdateCurrentStep(OAuthStep.SIGN_UP);
    }
  }

  return <OAuthLandingPage onUpdateCurrentStep={onUpdateCurrentStep} />;
};

export { OAuthExternalApplicationStep };
